// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_1b1f25', '__Roboto_Fallback_1b1f25'","fontWeight":700,"fontStyle":"normal"},"className":"__className_1b1f25"};